import { Colorset } from './colorset';
import { Scale } from './scale';
import { Unit } from './unit';

export interface Legend {
  uid?: number;
  indicatorData?: number;
  textTop?: string;
  textBottom?: string;
  yearLabel?: string;
  noDataLabel?: string;
  redLines?: string;
  disabledYears?: string;
  lineMinMax: boolean;
  radioMode: boolean;
  districtMode: boolean;
  yearlyMode: boolean;
  scales?: Scale[];
  colorsetUid?: number;
  colorset?: Colorset;
  indicatorSubtitle?: string;
  type: string;
  decimals?: number;
  maxAxisValue?: number;
}

export interface LegendMode {
  name: string;
  key: string;
}

export const legendModes: LegendMode[] = [
  {
    name: 'Standard',
    key: 'default',
  },
  {
    name: 'Gleiche Klassenbreiten',
    key: 'classWidth',
  },
  {
    name: 'Gleiche Klassenbesetzung',
    key: 'classCount',
  },
  {
    name: 'Manuell',
    key: 'fixed',
  },
];
